import React from 'react';
import Modal from 'react-bootstrap/Modal';

export default class extends React.Component {
  render() {
    return (
      <div className='modalStyles'>
        <div
          className='modalStyle'
          style={{ background: 'black', opacity: '0.5' }}
        >
          <Modal
            show={this.props.showModal}
            onHide={this.props.close}
            id='myModal'
          >
            <Modal.Header closeButton>
              <Modal.Title> </Modal.Title>
            </Modal.Header>
            <Modal.Body>{this.props.renderModalBody}</Modal.Body>
            <Modal.Footer style={{ textAlign: 'center' }}>
              <img
                style={{ width: '30px', height: '34px' }}
                src='https://www.paypalobjects.com/webstatic/logo/med-monogram.png'
              />
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}
